import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ProductTypeBody from "components/AdministrationComponents/ProductType/ProductTypeBody";

const ProductType = () => {
  useEffect(() => {
    document.title = "Administration | Product Type";
  }, []);

  return (
    <main id="app">
      <Header moduleName="administration" />
      <ProductTypeBody />
    </main>
  );
};

export default ProductType;
